import * as React from 'react';

interface Props {
  overwriteCount: number;
}

export const OverwriteWarning: React.FC<Props> = (props: Props) => {
  const { overwriteCount } = props;
  return (
    <div className="bg-orange-50 p-3">
      <h4>
        {overwriteCount} of the selected containers already {overwriteCount > 1 ? 'have' : 'has'} a
        customer ID. Saving your changes will replace their current customer ID.
      </h4>
    </div>
  );
};
OverwriteWarning.displayName = 'AssignmentModal.OverwriteWarning';
